<template>
  <div class="service-page">
    <h1>{{ header }}</h1>
    <p>{{ subheader }}</p>

    <mobile-cart :service="service" class="mobile-cart" />

    <div class="main-content">
      <div class="content-wrapper">
        <div class="progress-indicator">
          <pn-progress-indicator
            :active-step="activeStep"
            @setactivestep="setActiveStep"
          >
            <pn-progress-indicator-step
              v-for="(step, i) in steps"
              :key="i"
              :name="$t(step.name)"
              :value="step.route"
            >
              <pn-icon :symbol="step.symbol"></pn-icon>
            </pn-progress-indicator-step>
          </pn-progress-indicator>
        </div>

        <section class="service-page-content">
          <transition name="page-transition" mode="out-in">
            <router-view class="send-service-page"></router-view>
          </transition>
        </section>
      </div>

      <cart :service="service" />
    </div>
  </div>
</template>

<script>
import Cart from '@/components/common/CartComponent'
import MobileCart from '@/components/common/MobileCartComponent'

export default {
  components: { Cart, MobileCart },
  props: {
    service: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    subheader: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      default: () => [
        { name: 'W2P_PROGRESS_UPLOAD', symbol: 'upload', route: '/upload' },
        {
          name: 'W2P_PROGRESS_ADDRESS',
          symbol: 'map-marker',
          route: '/address'
        },
        {
          name: 'W2P_PROGRESS_DELIVERY',
          symbol: 'envelope',
          route: '/delivery'
        },
        { name: 'W2P_PROGRESS_PAYMENT', symbol: 'credit-card', route: '/pay' }
      ]
    }
  },
  data: () => ({
    activeStep: 0
  }),
  methods: {
    checkStep() {
      this.steps.forEach((step, i) => {
        if (this.$route.path.includes(`/${this.service}${step.route}`)) {
          this.activeStep = i
        }
      })
    },
    setActiveStep(e) {
      if (this.$route.meta.disableProgressBar) {
        return
      }
      this.activeStep = e.detail
    }
  },
  computed: {
    path() {
      return `/${this.service}${this.steps[this.activeStep].route}`
    }
  },
  watch: {
    activeStep() {
      if (
        this.$route.path.includes(this.path) ||
        this.$route.meta.disableProgressBar
      )
        return
      this.$router.push({ path: this.path })
    },
    $route() {
      this.checkStep()
    }
  },
  mounted() {
    this.checkStep()
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.content-wrapper {
  flex: 1;
  margin-right: 3em;
  width: 46em;
}

.service-page-content {
  margin-top: 2em;
}

.send-service-page {
  border: 0.1rem solid $gray50;
  padding: 3em 4em;
}

h1 {
  color: $black;
}

p {
  margin: 1.5em 0 3em;
  color: $gray700;
}

@media screen and (max-width: 50em) {
  .send-service-page {
    padding: 0;
    border: none;
  }
}

@media screen and (max-width: 75em) {
  .content-wrapper {
    margin: 0;
    width: 100%;
  }
}
</style>
